import AsyncJobManager from '@aytm/lib/AsyncJobManager/AsyncJobManager'
import ImageAssetUploadJob from '@aytm/lib/AsyncJobManager/jobs/assets/ImageAssetUploadJob'

import { identity } from './functions'

export type Image = {
  id?: string
  uid?: string
  original?: {
    url: string
    path: string
    title: string | null
    width: number
    height: number
  }
  expand?: boolean
  scrolling?: boolean
  error?: Error | null
}

const ImageAssetUploadManager = AsyncJobManager({ concurrency: 2 })

export const imageUpload = (url: string, file: File) =>
  new Promise((resolve, reject) => {
    const createAssetPath = url
    if (!file || !createAssetPath) {
      reject({ error: new Error('Error uploading image') })
      return
    }
    const uploadJob = ImageAssetUploadJob({ createAssetPath, file })
    const uploadQueue = ImageAssetUploadManager.queue(uploadJob) as ProgressivePromise<Image>
    void uploadQueue.then(identity, null, (type, _jobIndex, _loaded, _total, status, result) => {
      const { id, uid, original, error } = (result as unknown as Image) || {}
      if ('done' === type.toString()) {
        if ('done' === status.toString()) {
          resolve({ id, uid, original, expand: true, scrolling: false })
        } else {
          reject(error || new Error('Error uploading image'))
        }
      }
    })
  })
